/**
 * mcycle homepage Q&A module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/11
 */
import './index.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';

class QA extends Component {
  render() {
    const problemConfigs = this.props.pageInfo.problemConfigs;

    return (
      <div className="mcycle-home-qa">
        <div className="mcycle-home-qa-title">常见问题解答</div>
        {
          problemConfigs.map((item, index) => (
            <ul className="mcycle-home-qa-content" key={ index }>
              <li className="mcycle-home-qa-question">{ item.title }</li>
              {
                item.contents.map((e, i) => (
                  <li className="mcycle-home-qa-answer" key={`in-${i}`} dangerouslySetInnerHTML={{ __html: e.content }}/>
                ))
              }
            </ul>
          ))  
        }
      </div>
    )
  }
}

export default connect(
  state => ({
    pageInfo: state.home.pageInfo
  })
)(QA)


// WEBPACK FOOTER //
// ./src/components/home/qa/index.js